/**
 * Gets Value of Key from Corrected Value or Value
 * @param {object} obj - The string to check.
 * @returns {string} - Returns value if is not null.
 */
export function getKeyValue(obj) {
    if (obj === undefined || obj === null) {
        return null;
    }

    return obj?.correctedValue ?? obj?.value;
}

/**
 * Gets Value from  Key
 * @param {id} str - The string to check.
 * @param {array} data - The data array.
 * @returns {string} - Returns value if is not null.
 */
export function findKVPValue(id, data) {
    return (
        getKeyValue(data.find((item) => item.key === id))
    );
}

/**
 * Gets Item
 * @param {id} str - The string to check.
 * @param {array} data - The data array.
 * @param {int?} index - The data index array.
 * @returns {object} - Returns item if is not null.
 */
export function findItem(id, data, index) {
    return (
        index === null ? (data.find((item) => item.key === id) ?? null) : (data.find((item) => item.key === id && item.index === index) ?? null)
    );
}

/**
 * Gets Value from  Key
 * @param {id} str - The string to check.
 * @param {int} index - The data Index
 * @param {array} data - The data array.
 * @returns {string} - Returns value if is not null.
 */
export function findIndexData(id, index, data) {
    return (
        getKeyValue(data.find((item) => item.key === id && item.lineIndex === index))
    );
}

/**
 * Gets Value from  Key
 * @param {string} value - The value to be split
 * @returns {string} - Returns value if is not null.
 */
export function splitValue(value, character = "-", indexToTake = 1) {
    if (value) {
        const splitValue = value.split(character);
        if (splitValue.length >= indexToTake && splitValue[indexToTake]) {
            return splitValue[indexToTake];
        }
    }
    return value;
}